import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateUserEmailParams {
  userId: string; // server user id
  email: string;
}

export class UpdateUserEmailRequest extends Request<IUpdateUserEmailParams, IResult> {
  constructor(params: IUpdateUserEmailParams) {
    super('updateUserEmail', params);
  }
}
